import React, { memo, useCallback, useState } from 'react';
import useFilterData from '../../../hooks/useFilterData';
import useSortableData from '../../../hooks/useSortableData';
import { exportCSVFile } from '../../../utils/exportFile';
import Icon from '../../icon/Icon';
import PaginationButtons, { dataPagination } from '../../PaginationButtons';

const TableCustom = ({ columns, rows, keyExtractor, noShowHeader, title, simple, noShowPaginate }) => {
  const [search, setsearch] = useState('');
  const dataFilter = useFilterData(rows, search)
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const { items, requestSort, getClassNamesFor } = useSortableData(dataFilter);
  const onCurrentPageData = dataPagination(items, currentPage, perPage);

  const onExport = useCallback(() => {
    const dataExport = dataFilter.map((row) => {
      const data = {};
      columns.forEach((c) => {
        if (c.noExport) return;
        const field = c.field;
        let cell = c.formatExport
          ? c.formatExport(field === '{row}' ? row : row[field])
          : row[field];
        cell = cell === undefined ? ' ' : cell;
        data[c.label] = cell;
      });
      return data;
    });
    exportCSVFile(dataExport, 'dados')
  }, [columns, dataFilter])

  return (
    <>
      <table className='table table-modern'>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={'tab-head-' + column.label} onClick={() => requestSort(column.field)}>
                {column.label.toUpperCase()}
                <Icon
                  size='sm'
                  className={getClassNamesFor(column.field)}
                  icon='FilterList'
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {onCurrentPageData.map((item, index) => (
            <tr key={keyExtractor ? keyExtractor(item) : item.id}>
              {columns.map((c, index2) => (
                <td key={`tab-cell-${item.id}-${index}-${index2}`}>
                  {c.format ? c.format(item) : item[c.field]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {!noShowPaginate &&
        <PaginationButtons
          data={items}
          label='items'
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          perPage={perPage}
          simple_per_count={simple}
          setPerPage={setPerPage}
        />
      }
    </>
  );
};

export default memo(TableCustom);
